<script setup lang="ts">
defineProps<{
  boarderStyle?: 'outlined' | 'ghost';
  disabled: boolean;
}>();
</script>

<template>
  <button
    type="button"
    class="flex h-12 cursor-pointer items-center justify-center px-8 text-base font-semibold transition-all select-none"
    :class="{
      'border-light-border dark:border-dark-brd-dark rounded-full border':
        !boarderStyle || boarderStyle === 'outlined',
    }"
    :disabled="disabled"
    :data-test="$attrs['data-test']"
    @click="$emit('clicked')"
  >
    <slot />
  </button>
</template>
